// 장애 이력 모델. 백엔드 entity.SiteIncident 와 1:1 매칭.
import type { CreatedByFields } from './CreatedBy';

export type IncidentSeverity = 'low' | 'medium' | 'high' | 'critical';
export type IncidentStatus =
  | 'open'
  | 'investigating'
  | 'in_progress'
  | 'on_hold'
  | 'resolved'
  /** 레거시. 기존 데이터 호환용으로만 유지. 신규 입력에는 사용하지 않음 (resolved 와 동일하게 "완료" 로 표시). */
  | 'closed';

export const INCIDENT_SEVERITIES: IncidentSeverity[] = ['low', 'medium', 'high', 'critical'];

/** 사용자가 셀렉트에서 고를 수 있는 5개 상태 (운영팀 요청 라이프사이클). */
export const INCIDENT_STATUSES: IncidentStatus[] = [
  'open',
  'investigating',
  'in_progress',
  'on_hold',
  'resolved',
];

export const SEVERITY_LABEL: Record<IncidentSeverity, string> = {
  low: '낮음',
  medium: '보통',
  high: '높음',
  critical: '치명',
};

export const STATUS_LABEL: Record<IncidentStatus, string> = {
  open: '장애 발생',
  investigating: '검토 중',
  in_progress: '처리 중',
  on_hold: '보류',
  resolved: '완료',
  // 레거시 데이터 호환 — 신규에는 사용하지 않으나 화면 표시는 "완료" 와 동일하게.
  closed: '완료',
};

/**
 * 장애 보고 대상이 될 수 있는 서비스 이름 후보 — `services/` 디렉토리 기준.
 * 운영 환경에서 인시던트가 발생할 수 있는 서비스만 포함. 빌드 툴/공유 모듈 제외.
 * 자유 입력도 허용하기 위해 Autocomplete `freeSolo` 와 함께 사용.
 */
export const SERVICE_NAMES: readonly string[] = [
  'smartparking-router',
  'smartparking-gateway',
  'smartparking-manage-backend',
  'smartparking-manage',
  'smartparking-camera-server',
  'parking-map-client',
  'lights',
  'ht_location',
  'parking_induce',
  'rtspback',
];

export interface SiteIncident extends CreatedByFields {
  id: number;
  site_project_id: number;
  occurred_at: string;
  resolved_at?: string | null;
  severity: IncidentSeverity;
  status: IncidentStatus;
  /** 영향받은 서비스 식별자. 자유 문자열. */
  service_name?: string;
  title: string;
  summary?: string;
  root_cause?: string;
  action_taken?: string;
  /** 담당자 */
  assignee?: string;
  reported_by?: string;
  /** 비고 (자유 입력) */
  remark?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateSiteIncidentRequest {
  occurred_at: string;
  resolved_at?: string | null;
  severity: IncidentSeverity;
  status: IncidentStatus;
  service_name?: string;
  title: string;
  summary?: string;
  root_cause?: string;
  action_taken?: string;
  assignee?: string;
  reported_by?: string;
  remark?: string;
}

export interface UpdateSiteIncidentRequest {
  occurred_at?: string;
  resolved_at?: string | null;
  severity?: IncidentSeverity;
  status?: IncidentStatus;
  service_name?: string;
  title?: string;
  summary?: string;
  root_cause?: string;
  action_taken?: string;
  assignee?: string;
  reported_by?: string;
  remark?: string;
}
